import { ArrowRight, Clock, MapPin, FileText, CaretDown } from '@phosphor-icons/react';

const OpenComplaintCard = ({ complaint, qrCodeUrl, reportUrl, elapsed, onDispatch }) => {
    const officer = complaint.received_by;
    const receivedBy = officer && typeof officer === 'object'
        ? [officer.first_name, officer.last_name].filter(Boolean).join(' ') : '';
    const fields = [
        ['Tehsil', complaint.complaint_tehsil_id?.name],
        ['Source', complaint.complaint_source],
        ['Referred by', complaint.complaint_reffered_by],
        ['Received by', receivedBy],
        ['Date of call', complaint.time_of_call ? new Date(complaint.time_of_call).toLocaleString() : ''],
    ];
    return (
        <article className="open-record-card" data-priority={complaint.priority_level}>
            <header className="open-record-header">
                <div><span className="open-record-kicker">Awaiting dispatch</span><h3>{complaint.complaint_number || 'Complaint'}</h3></div>
                <span className="open-record-priority"><span aria-hidden="true" />{complaint.priority_level || 'Unspecified'}</span>
            </header>
            <div className="open-record-summary">
                <span className="open-record-nature"><FileText size={19} weight="duotone" aria-hidden="true" />{complaint.complaint_nature_id?.name || 'Nature not specified'}</span>
                <span className="open-record-location"><MapPin size={16} weight="duotone" aria-hidden="true" />{complaint.complaint_district_id?.name || 'District not specified'}<span>·</span>{complaint.dept_id?.name || 'Department not specified'}</span>
            </div>
            <div className="open-record-wait"><Clock size={16} weight="duotone" aria-hidden="true" />Waiting since call <strong>{elapsed}</strong></div>
            <div className="open-record-information">
                <dl>{fields.map(([label, value]) => <div key={label}><dt>{label}</dt><dd>{value || '—'}</dd></div>)}</dl>
                <a className="open-record-qr" href={reportUrl} target="_blank" rel="noopener noreferrer" aria-label={`Open report for ${complaint.complaint_number}`}>
                    {qrCodeUrl ? <img src={qrCodeUrl} alt={`QR code for ${complaint.complaint_number}`} /> : <FileText size={28} aria-hidden="true" />}
                    <span>View report</span>
                </a>
            </div>
            <details className="open-record-details">
                <summary>Address, description &amp; remarks <CaretDown size={16} aria-hidden="true" /></summary>
                <dl>{[
                    ['Nearby place', complaint.near_by_place],
                    ['Address', complaint.complaint_address],
                    ['Description', complaint.description || complaint.complaint_detail],
                    ['Remarks', complaint.remarks],
                ].map(([label, value]) => <div key={label}><dt>{label}</dt><dd>{value || '—'}</dd></div>)}</dl>
            </details>
            <footer className="open-record-footer"><span>Assign an officer to begin processing</span><button type="button" onClick={onDispatch}>Dispatch complaint <ArrowRight size={17} aria-hidden="true" /></button></footer>
        </article>
    );
};

export default OpenComplaintCard;
